export const LANGS_RU = {
  en: 'Английский',
  ru: 'Русский',
};
